import styled from 'styled-components';

export const ProjectTabList = styled.div`
  width: 260px;
  margin: 0 0 12px;
  margin-left: -7px;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: space-between;
  position: relative;
  span {
    background: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.blueLight']
      : props.theme['color.blackLighter']};
    top: auto;
    right: auto;
    position: absolute;
    border:${(props) =>
    props.theme.themeId === 'dark'
      ? `2px solid  ${props.theme['color.blueLight']}`
      : `2px solid ${props.theme['color.blackLighter']}`};
    margin-bottom:-13px
  }
`;

export const ProjectTab = styled.div`
line-height: 18px;
position: relative;
display: flex;
flex: 1 0 auto;
padding: 8px;
text-align: center;
cursor: pointer;
color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.greyDark']
      : props.theme['color.blackLighter']};
align-content: center;
justify-content: center;
font-size: 14px;
font-weight: 600;
letter-spacing: 0.08em;
&:hover {
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.blueLight']
      : props.theme['color.blackLighter']};
  }
`;

export const ProjectDividerLine = styled.div`
align-self: stretch;
margin-top: -18px;
border-bottom: ${(props) =>
    props.theme.themeId === 'dark'
      ? `2px solid ${props.theme['color.blackLight']}`
      : `2px solid ${props.theme['color.greyDark']}`};
width: 100%;
`;